export function BridgeUser({
    apikey,
    name,
    email,
    isDistributor = false,
    isDistributorManager = false,
} = {}) {
    return {
        apikey,
        name,
        email,
        isDistributor,
        isDistributorManager,
    };
}